<template>
    <div>
        <headBox :title="title" :ti="ti" :gameid="gameid" ></headBox>
    </div>
</template>

<script>
import headBox from '@/public/header/head'
export default {
  
  data () {
   return {
       title:'2',
       ti:'',
       gameid:''
   }
  },
  components:{
      headBox
  },
  mounted()
  {
      
      localStorage.removeItem('printGameid');
      localStorage.removeItem('printTi')
  }
}
</script>



// WEBPACK FOOTER //
// src/view/login.vue